jQuery(document).ready(function($) {
	// Handler for .ready() called.  
});
